// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;You crown the year with your goodness,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and your paths overflow with plenty.<br> </p> </div></div>";
// Exports
module.exports = code;